export default "__VITE_ASSET__DENSMEcJ__"